document.addEventListener("DOMContentLoaded", () => {
  if (!window.STORE_LOCATIONS) window.STORE_LOCATIONS = [];

  // -------- Filter valid stores --------
  const STORES = STORE_LOCATIONS.filter(s => s.lat && s.lng);

  // -------- Map Setup --------
  const map = L.map('map', {
    scrollWheelZoom: false,
    tap: false
  });

  const CARTO_API_KEY = "cb1_3hga_1_68034e4d4a6d50188bf806ab";

  L.tileLayer(
  'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_3hga_1_68034e4d4a6d50188bf806ab',
  {
    maxZoom: 19,
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
  }
  ).addTo(map);

  // -------- Icons --------
  const ICON_OPEN = L.icon({
    iconUrl: "https://cdn.shopify.com/s/files/1/1804/7057/files/tc-map-pin-open.png?v=1769475559",
    iconSize: [32, 32]
  });

  const ICON_CLOSED = L.icon({
    iconUrl: "https://cdn.shopify.com/s/files/1/1804/7057/files/tc-map-pin-closed.png?v=1769475559",
    iconSize: [32, 32]
  });

  const ICON_USER = L.icon({
    iconUrl: "https://cdn.shopify.com/s/files/1/1804/7057/files/tc-map-pin-user.png?v=1769475559",
    iconSize: [32, 32]
  });

  let userMarker;

  // -------- Time Helpers --------
  function timeToMin(t) {
    if (!t) return null;
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
  }

  function getLocalMinutes(timezone) {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).formatToParts(new Date());

    return (+parts.find(p => p.type === "hour").value * 60) +
           +parts.find(p => p.type === "minute").value;
  }

  function getDayKey(timezone, offset = 0) {
    const d = new Date();
    d.setDate(d.getDate() + offset);
    const dayIndex = new Date(
      new Intl.DateTimeFormat("en-US", { timeZone: timezone }).format(d)
    ).getDay();

    return ["sun", "mon", "tue", "wed", "thu", "fri", "sat"][dayIndex];
  }

  function getLocalDate(timezone, offset = 0) {
    const d = new Date();
    d.setDate(d.getDate() + offset);
    return new Intl.DateTimeFormat("en-CA", { timeZone: timezone }).format(d);
  }

  // -------- GET HOURS (with exceptions) --------
  function getHours(store, offset = 0) {
    const now = new Date(new Date().toLocaleString("en-US", { timeZone: store.timezone }));
    now.setDate(now.getDate() + offset);
    const todayStr = now.toISOString().split('T')[0];

    const exc = store.exceptions?.find(e => e.date === todayStr);
    if (exc) {
      // If times exist, return them along with name
      if (exc.open && exc.close) return { hours: [exc.open.toString(), exc.close.toString()], exceptionName: exc.name || null };
      // If no times, store is closed due to exception
      return { hours: null, exceptionName: exc.name || null };
    }

    const dayKey = ['sun','mon','tue','wed','thu','fri','sat'][now.getDay()];
    const h = store.hours[dayKey];
    if (!h || !h[0] || !h[1]) return { hours: null, exceptionName: null };

    return { hours: [h[0].toString(), h[1].toString()], exceptionName: null };
  }

  function formatAMPM(time24) {
    if (!time24) return "";
    const [h, m] = time24.split(":").map(Number);
    const ampm = h >= 12 ? "PM" : "AM";
    const hour = h % 12 === 0 ? 12 : h % 12;
    return `${hour}:${m.toString().padStart(2, "0")} ${ampm}`;
  }

  // -------- IS STORE OPEN NOW --------
  function isOpenNow(store) {
    const { hours } = getHours(store);
    if (!hours) return false;

    const now = new Date(new Date().toLocaleString("en-US", { timeZone: store.timezone }));
    const [openH, openM] = hours[0].split(":").map(Number);
    const [closeH, closeM] = hours[1].split(":").map(Number);

    const open = new Date(now); open.setHours(openH, openM, 0, 0);
    const close = new Date(now); close.setHours(closeH, closeM, 0, 0);

    return now >= open && now <= close;
  }

  // -------- GET STORE STATUS --------
  function getStatus(store) {
    const { hours, exceptionName } = getHours(store);
    if (!hours) {
      return exceptionName ? `Closed for ${exceptionName}` : "Closed";
    }

    const now = new Date(new Date().toLocaleString("en-US", { timeZone: store.timezone }));
    const [openH, openM] = hours[0].split(":").map(Number);
    const [closeH, closeM] = hours[1].split(":").map(Number);

    const open = new Date(now); open.setHours(openH, openM, 0, 0);
    const close = new Date(now); close.setHours(closeH, closeM, 0, 0);

    if (now < open) return `Opens at ${formatAMPM(hours[0])}`;
    if (now > close) return exceptionName ? `Closed for ${exceptionName}` : "Closed";
    return `Open until ${formatAMPM(hours[1])}`;
  }

  // -------- GET TOMORROW HOURS --------
  function getTomorrowHours(store) {
    const { hours, exceptionName } = getHours(store, 1);
    if (!hours) return exceptionName ? `Closed for ${exceptionName}` : "Closed";
    return `${formatAMPM(hours[0])} – ${formatAMPM(hours[1])}`;
  }

  function distance(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function kmToMiles(km) {
    return km * 0.621371;
  }

  function directionsLink(lat, lng) {
    return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  }

  // -------- Markers --------
  STORES.forEach(store => {
    store.marker = L.marker(
      [store.lat, store.lng],
      { icon: isOpenNow(store) ? ICON_OPEN : ICON_CLOSED }
    )
      .addTo(map)
      .bindPopup(`
        <div class="popup-content">
            <div class="popup-header">
              <strong class="popup-title">${store.name}</strong>
              ${store.distanceMi ? `
                <div class="popup-distance">
                  ${store.distanceMi.toFixed(1)} miles away
                </div>
              ` : ``}
            </div>

            <div class="popup-body">
              <div class="popup-address">${store.address}</div>

              ${store.phone ? `
                <div class="popup-phone">
                  <a href="tel:${store.phone.replace(/[^0-9+]/g, '')}">
                    ${store.phone}
                  </a>
                </div>
              ` : ``}

              <div class="popup-status">
                ${getStatus(store)}
              </div>

              <div class="popup-tomorrow">
                Tomorrow: ${getTomorrowHours(store)}
              </div>
            </div>

            <div class="popup-actions">
              <a
                href="${directionsLink(store.lat, store.lng)}"
                target="_blank"
                rel="noopener"
                class="popup-btn"
              >
                Get Directions
              </a>
            </div>
          </div>
      `);
  });

  function updatePopups() {
    STORES.forEach(store => {
      if (!store.marker) return;

      store.marker.setPopupContent(`
        <div class="popup-content">
          <div class="popup-header">
            <strong class="popup-title">${store.name}</strong>
            ${store.distanceMi ? `
              <div class="popup-distance">
                ${store.distanceMi.toFixed(1)} miles away
              </div>
            ` : ``}
          </div>

          <div class="popup-body">
            <div class="popup-address">${store.address}</div>

            ${store.phone ? `
              <div class="popup-phone">
                <a href="tel:${store.phone.replace(/[^0-9+]/g, '')}">
                  ${store.phone}
                </a>
              </div>
            ` : ``}

            <div class="popup-status">
              ${getStatus(store)}
            </div>

            <div class="popup-tomorrow">
              Tomorrow: ${getTomorrowHours(store)}
            </div>
          </div>

          <div class="popup-actions">
            <a
              href="${directionsLink(store.lat, store.lng)}"
              target="_blank"
              rel="noopener"
              class="popup-btn"
            >
              Get Directions
            </a>
          </div>
        </div>
      `);
    });
  }


  // -------- Auto-fit map to stores --------
  if (STORES.length) {
    const bounds = L.latLngBounds(STORES.map(s => [s.lat, s.lng]));
    map.fitBounds(bounds, { padding: [40, 40] });
  }

  // -------- Store List --------
  function renderList(stores) {
    const el = document.getElementById("store-list");
    el.innerHTML = stores.map(store => `
      <div class="store-card" data-lat="${store.lat}" data-lng="${store.lng}">
        <div class="store-card-header">
          <strong class="store-name">${store.name}</strong>
          <span class="badge ${isOpenNow(store) ? "open" : "closed"}">
            ${isOpenNow(store) ? "OPEN" : "CLOSED"}
          </span>
        </div>

        ${store.distanceMi ? `
          <div class="store-distance">
            ${store.distanceMi.toFixed(1)} miles away
          </div>
        ` : ``}

        <div class="store-address">${store.address}</div>

        ${store.phone ? `
          <div class="store-phone">
            <a href="tel:${store.phone.replace(/[^0-9+]/g, '')}">
              ${store.phone}
            </a>
          </div>
        ` : ``}

        <div class="store-status">
          ${getStatus(store)}
        </div>

        <div class="store-actions">
          <a
            href="${directionsLink(store.lat, store.lng)}"
            target="_blank"
            rel="noopener"
            class="store-btn"
          >
            Get Directions
          </a>
        </div>
      </div>
    `).join("");

    el.querySelectorAll(".store-card").forEach(card => {
      card.onclick = () => {
        map.setView([+card.dataset.lat, +card.dataset.lng], 13);
        const store = STORES.find(
          s => s.lat == card.dataset.lat && s.lng == card.dataset.lng
        );
        store?.marker?.openPopup();
      };
    });
  }

  renderList(STORES);

  // -------- Geocoding --------
  async function geocode(address) {
    let url;

    if (/^\d{5}$/.test(address)) {
      // ZIP code lookup (most accurate)
      url = `https://nominatim.openstreetmap.org/search?postalcode=${address}&countrycodes=us&format=json`;
    } else {
      // General search (forced to US)
      url = `https://nominatim.openstreetmap.org/search?format=json&countrycodes=us&q=${encodeURIComponent(address + ', USA')}`;
    }

    const res = await fetch(url);
    const data = await res.json();
    if (!data.length) throw "Not found";

    return { lat: +data[0].lat, lng: +data[0].lon };
  }

  document.getElementById("store-search-btn").onclick = async () => {
  const query = document.getElementById("store-search").value;
  if (!query) return;

  try {
    const loc = await geocode(query);

    // Calculate distances
    STORES.forEach(s => {
      const km = distance(loc.lat, loc.lng, s.lat, s.lng);
      s.distanceKm = km;
      s.distanceMi = kmToMiles(km);
    });

    // Sort by nearest
    STORES.sort((a, b) => a.distanceKm - b.distanceKm);
    const closestStore = STORES[0];

    // User marker
    if (userMarker) map.removeLayer(userMarker);
    userMarker = L.marker([loc.lat, loc.lng], { icon: ICON_USER }).addTo(map);

    // Fit map to user + closest store
    const bounds = L.latLngBounds([
      [loc.lat, loc.lng],
      [closestStore.lat, closestStore.lng]
    ]);

    map.fitBounds(bounds, {
      padding: [60, 60],
      maxZoom: 13
    });

    closestStore.marker.openPopup();

    // Update popup content with distance
    updatePopups();

    // Render sorted list
    renderList(STORES);

  } catch {
    alert("Address not found");
  }
};
});
